import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({
  buttons: { menuButton, primary, secondary, tertiary },
  spacing: { unit },
}: ComposedTheme) => ({
  caret: {
    marginLeft: unit,
  },
  root: {
    display: 'inline-block',
    position: 'relative',
  },
  dropdownButton: {
    alignItems: 'center',
    background: menuButton.background,
    border: `1px solid ${menuButton.borderColor}`,
    borderRadius: menuButton.borderRadius,
    color: menuButton.fontColor,
    cursor: 'pointer',
    display: 'flex',
    fontFamily: menuButton.fontFamily,
    fontSize: menuButton.fontSize,
    height: 40,
    minWidth: 80,
    padding: [10, 24],
    '&:focus': {
      ...(primary.outlineReplacement
        ? { outline: 'none', boxShadow: primary.outlineReplacement }
        : undefined),
    },
    '&:hover': {
      background: menuButton.backgroundHover,
    },
    '& svg': {
      fill: menuButton.fontColor,
    },
  },
  isOpen: {
    borderRadius: [menuButton.borderRadius, menuButton.borderRadius, 0, 0],
    '& $dropdownButton': {
      borderRadius: [menuButton.borderRadius, menuButton.borderRadius, 0, 0],
    },
  },
  dropdownMenu: {
    display: 'block',
    width: '100%',
    position: 'absolute',
    top: 40,
    zIndex: 1,
    left: 0,
    padding: 0,
    margin: 0,
    listStyle: 'none',
    border: `1px solid ${menuButton.borderColor}`,
    borderRadius: [0, 0, menuButton.dropdownRadius, menuButton.dropdownRadius],
    background: menuButton.dropdownBackground,
  },
  dropdownMenuItem: {
    '&:hover': {
      backgroundColor: menuButton.dropdownMenuHover,
    },
    '&:last-child': {
      borderRadius: [0, 0, menuButton.dropdownRadius, menuButton.dropdownRadius],
    },
  },
  dropdownAction: {
    border: 'none',
    cursor: 'pointer',
    background: 'transparent',
    padding: [5, 14],
    textAlign: 'left',
    width: '100%',
    fontSize: menuButton.fontSize,
    fontFamily: menuButton.fontFamily,
    lineHeight: menuButton.lineHeight,
    ...(menuButton.dropdownActionColor ? { color: menuButton.dropdownActionColor } : undefined),
  },
  primary: {
    background: menuButton.primary.background,
    color: menuButton.primary.fontColor,
    '&:hover': {
      background: menuButton.primary.backgroundHover,
    },
    '& svg': {
      fill: menuButton.primary.fontColor,
    },
  },
  secondary: {},
  normal: {},
  tertiary: {
    background: menuButton.tertiary.background,
    border: 0,
    color: menuButton.tertiary.fontColor,
    '&:focus': {
      outline: 'none',
      boxShadow: 'none',
    },
    '&:hover': {
      background: menuButton.tertiary.backgroundHover,
      textDecoration: 'underline',
    },
    '& svg': {
      fill: menuButton.tertiary.fontColor,
    },
    '& + $dropdownMenu': {
      borderRadius: menuButton.dropdownRadius,
      '& $dropdownMenuItem:first-child': {
        borderRadius: [menuButton.dropdownRadius, menuButton.dropdownRadius, 0, 0],
      },
    },
  },
  small: {
    fontSize: menuButton.small.fontSize,
    height: 30,
    padding: [5, 25],
    '&$isOpen': {
      borderRadius: [menuButton.small.borderRadius, menuButton.small.borderRadius, 0, 0],
    },
    '& + $dropdownMenu': {
      top: 30,
    },
  },
  extraSmall: {
    fontSize: menuButton.extraSmall.fontSize,
    height: 22,
    minWidth: 64,
    padding: [2, 20],
    '&$isOpen': {
      borderRadius: [menuButton.extraSmall.borderRadius, menuButton.extraSmall.borderRadius, 0, 0],
    },
    '& + $dropdownMenu': {
      top: 22,
    },
  },
  disabled: {
    '&$secondary': {
      backgroundColor: secondary.disabledBackground,
      borderColor: secondary.disabledBorder,
      color: secondary.disabledColor,
      cursor: 'not-allowed',
      '& svg': {
        fill: secondary.disabledColor,
      },
    },
    '&$primary': {
      backgroundColor: primary.disabledBackground,
      borderColor: primary.disabledBorder,
      color: primary.disabledColor,
      cursor: 'not-allowed',
      '& svg': {
        fill: primary.disabledColor,
      },
    },
    '&$tertiary': {
      color: tertiary.disabledColor,
      textDecoration: 'none',
      cursor: 'not-allowed',
      '& svg': {
        fill: tertiary.disabledColor,
      },
    },
  },
});

export default createUseStyles(styles);
